const returnTop = () => {
    const returnBtn = document.querySelector(".return-top");
    if (returnBtn) {
        returnBtn.addEventListener("click", function() {
           window.scrollTo(0,0);
        });
    }
}
export default returnTop;